import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/wholesale")({
  component: lazyRouteComponent(() => import("./-pages/admin.wholesale")),
});
